import { ROUTES } from "../../constants/routes";
import { Component, inject, signal } from "@angular/core";
import { RouterLink } from "@angular/router";
import { FormsModule } from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { Navbar } from "../../components/navbar/navbar";
import { Breadcrumb } from "../../components/breadcrumb/breadcrumb";
import { Footer } from "../../components/footer/footer";
import { SeoService } from "../../services/seo.service";
import { SITE } from "../../constants/site";
import { ICONS } from "../../constants/icons";
import { breadcrumbSchema, contactPageSchema } from "../../helpers/structured-data";

@Component({
  selector: "app-contact",
  imports: [RouterLink, FormsModule, Breadcrumb, Navbar, Footer],
  templateUrl: "./contact.html",
  styleUrl: "./contact.scss"
})
export class Contact {
  readonly routes = ROUTES;
  private readonly seo = inject(SeoService);
  private readonly sanitizer = inject(DomSanitizer);
  readonly site = SITE;

  readonly submitted = signal(false);

  readonly promises = [
    "Free sample run on your own file",
    "No contract to evaluate",
    "Straight answers on sourcing and coverage"
  ];

  readonly topics = [
    { value: "evaluate", label: "Evaluate the data" },
    { value: "pricing", label: "Pricing and volume" },
    { value: "api", label: "API and integration" },
    { value: "security", label: "Security review" },
    { value: "support", label: "Existing account" }
  ];

  readonly channels = [
    {
      icon: "phone",
      label: "Phone",
      value: SITE.phone,
      href: SITE.phoneHref,
      detail: "Monday to Friday, 9am to 6pm Pacific"
    },
    {
      icon: "user",
      label: "Sales",
      value: SITE.email,
      href: `mailto:${SITE.email}`,
      detail: "Pricing, pilots and volume agreements"
    },
    {
      icon: "shield",
      label: "Support",
      value: SITE.supportEmail,
      href: `mailto:${SITE.supportEmail}`,
      detail: "Existing accounts, billing and API issues"
    },
    {
      icon: "pin",
      label: "Office",
      value: SITE.address,
      href: "",
      detail: "A real, staffed United States address"
    }
  ];

  model = {
    name: "",
    email: "",
    company: "",
    phone: "",
    topic: "evaluate",
    volume: "",
    message: ""
  };

  iconFor(name: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(ICONS[name] ?? "");
  }

  submit(): void {
    // The backend endpoint is wired separately. This confirms the submission in the UI.
    this.submitted.set(true);
  }

  ngOnInit(): void {
    this.seo.apply({
      title: "Contact Sales | Talk to the VerifyDeceased Team",
      description:
        "Get in touch with the VerifyDeceased team about deceased verification, API access, pricing or a pilot. Reach us by form, email or phone.",
      path: "/contact",
      keywords:
        "contact VerifyDeceased, death verification sales, deceased verification demo, death data API access",
      structuredData: [
        breadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Contact", path: "/contact" }
        ]),
        contactPageSchema()
      ]
    });
  }
}
